import { useState, useEffect } from "react";

export type VisibilityModel = Record<string, { headerName: string, visibility: boolean }>;

/**
 * A custom hook that manages column visibility state in a table.
 * This hook provides functionality to control which columns are visible/hidden and
 * forces table re-render when visibility changes.
 *
 * @param initialModel - An object mapping column identifiers to their visibility states
 * @returns An object containing:
 *  - tableKey: A unique key that changes when visibility model updates
 *  - columnVisibilityModel: Current state of column visibility
 *  - setColumnVisibilityModel: Function to update column visibility
 *
 * @example
 * ```tsx
 * const { tableKey, columnVisibilityModel, setColumnVisibilityModel } = useColumnVisibilityModel({
 *   column1: true,
 *   column2: false
 * });
 * ```
 */
export function useColumnVisibilityModel(initialModel: Record<string, boolean>) {
	const [columnVisibilityModel, setColumnVisibilityModel] = useState(initialModel);
	const [tableKey, setTableKey] = useState("table");

	useEffect(() => {
		setTableKey(Math.random().toString());
	}, [columnVisibilityModel])

    return {
        tableKey,
        columnVisibilityModel,
        setColumnVisibilityModel,
    }
}